import script from "./AppDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppDetailPage.vue?vue&type=script&lang=ts&setup=true"

import "./AppDetailPage.vue?vue&type=style&index=0&id=61647568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61647568"]])

export default __exports__